import * as React from "react";
export function useCallbackRef() {
    const [current, setRef] = React.useState(null);
    return [current !== null && current !== void 0 ? current : undefined, setRef];
}
export function useRefs(...refs) {
    const [ref, setRef] = useCallbackRef();
    const setRefs = React.useCallback(function setRefs(current) {
        setRef((previous) => {
            if (previous !== current) {
                refs.forEach((ref) => {
                    if (!ref)
                        return;
                    else if (typeof ref === "function") {
                        ref(current);
                    }
                    else if (ref.current !== current) {
                        Object.assign(ref, { current });
                    }
                });
            }
            return current;
        });
    }, [refs, setRef]);
    return [ref, setRefs];
}
